<template>
  <a-select v-if="options.length>1" :value="currentCurrency" @change="change" :style="style">
    <a-select-option v-for="item in options" :key="item.item_id" :value="item.item_id">{{item.item_name}}</a-select-option>
  </a-select>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
// import { currencyUnitMap } from '@/constants/currency'
import { setCookieVal } from '@/utils/common/cookie'
// import { hasPermission } from '@/utils/auth'
import { getCurrencyOptions } from '@Bill/utils'

export default {
  name: 'BillCurrency',
  props: {
    storeSetDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      currentCurrency: this.$store.state.bill.currency,
    }
  },
  computed: {
    ...mapState('common', {
      currency: state => state.bill.currency,
      currencyOpts: state => state.bill.currencyOpts,
    }),
    options () {
      return getCurrencyOptions()
    },
    style () {
      let width = 300
      const lan = this.$store.getters.setting.language
      let len = 0
      this.options.map(item => {
        if (item.item_name.length > len) {
          len = item.item_name.length
        }
      })
      width = len * (lan === 'en' ? 7 : 14) + 34
      return `width:${width}px`
    },
  },
  watch: {
    currency: {
      handler: function (val) {
        this.currentCurrency = val
      },
      immediate: true,
    },
  },
  created () {
    // const params = { admin: this.$store.getters.isAdminMode, scope: this.$store.getters.scope }
    // if (hasPermission('bill_conditions_list')) {
    //   this.fetchCurrency(params)
    // }
  },
  methods: {
    ...mapMutations('common', {
      setCurrency: 'SET_BILL_CURRENCY',
    }),
    ...mapActions('common', ['fetchCurrency']),
    change (e) {
      const currency = e
      this.currentCurrency = currency
      this.$emit('change', currency)
      if (!this.storeSetDisabled) {
        setCookieVal('currency', currency)
        this.setCurrency(currency)
      }
    },
  },
}
</script>
